"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface TeamMember {
  id: number;
  name: string;
  title: string;
  bio: string;
  image: string;
  initials: string;
}
export default function TeamOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const team: TeamMember[] = [{
    id: 1,
    name: "Abdo Ibrahim",
    title: "Chairman & Founder",
    bio: "oversees the daily operations and strategic direction, acting as the primary bridge between the board of directors and the functional staff. responsible for driving revenue growth and ensuring that the management culture and resources align with its long-term goals.",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/02/hafez.png",
    initials: "SB"
  }, {
    id: 4,
    name: "Hafez Elsheikh",
    title: "Senior Auditor",
    bio: "leads the audit practice with meticulous attention to regulatory compliance and quality assurance, overseeing statutory audits, internal control assessments, and liquidation reports while ensuring adherence to UAE and international auditing standards.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/image_3yyffxv4.png",
    initials: "LI"
  }, {
    id: 5,
    name: "Mohamed Abdelmohsen",
    title: "Senior Auditor",
    bio: "provides comprehensive tax advisory services designed to navigate the UAE's regulatory environment. We specialize in end-to-end Corporate Tax compliance, VAT registration, and the procurement of Tax Residency Certificates, ensuring our clients remains fully compliant while optimizing its financial positioning.",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/01/abd-el-mohsen-2.png",
    initials: "OK"
  }, {
    id: 6,
    name: "Ahmed Ismail",
    title: "Senior Auditor",
    bio: "performs detailed audit procedures and analytical reviews, maintaining rigorous documentation standards while collaborating with client management teams to deliver comprehensive audit reports and actionable recommendations for financial process improvements.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/image_99xbv0ms.png",
    initials: "NA"
  }, {
    id: 2,
    name: "Abdo Ibrahim",
    title: "Client Relationship Manager",
    bio: "provides strategic leadership and operational oversight, ensuring seamless coordination across all departments while driving business development initiatives and maintaining the highest standards of professional service delivery to our valued clients.",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/01/abdu-4.png",
    initials: "FA"
  }, {
    id: 7,
    name: "Rifaat Zuhir",
    title: "Administration Manager",
    bio: "responsible for orchestrating the day-to-day functional rhythm of the organization, ensuring that every internal process is optimized for maximum efficiency by expertly coordinating administrative staff and streamlining logistical workflows, provide the robust structural support and foundational stability necessary for all other departments to achieve their specialized objectives.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/image_nly0iajz.png",
    initials: "TH"
  }];
  const founder = team[0];
  const remainingTeam = team.slice(1);
  return <section className="bg-background py-12 md:py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4 text-[hsl(22,78%,26%)]">
            Meet Our Team
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto px-4">
            Our dedicated professionals bring decades of combined expertise in
            audit, tax advisory, and financial consulting to serve your business
            needs.
          </p>
        </div>

        <div ref={ref}>
          {}
          <Card className={`group relative overflow-hidden border border-border shadow-soft hover:shadow-medium transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-0.5 mb-6 md:mb-8 lg:mb-12 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <CardContent className="p-0">
              <div className="flex flex-col">
                {}
                <div className="relative">
                  <SafeHydrate><Avatar className="w-full h-64 sm:h-80 md:h-96 rounded-none rounded-t-xl bg-muted">
                    <AvatarImage src="https://rational-stag.10web.cloud/wp-content/uploads/2026/01/salem-profile-photo-3-1.png" alt={founder.name} className="object-contain object-center w-full h-full" />
                    <AvatarFallback className="w-full h-full rounded-none bg-muted text-4xl md:text-5xl font-display font-semibold text-muted-foreground">
                      {founder.initials}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="absolute inset-0 rounded-t-xl border-2 border-transparent group-hover:border-primary/60 transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] pointer-events-none" />
                </div>

                {}
                <Card className="text-card-foreground flex flex-col gap-3 md:gap-4 rounded-none border-x-0 border-t-2 border-b-0 border-[hsl(45,90%,50%)] shadow-none py-4 md:py-6">
                  <CardContent className="p-4 sm:p-6">
                    <p className="text-muted-foreground text-sm leading-relaxed mb-4 md:mb-5 !text-justify">
                      Mr. Salem Mohamed Balama Al-Tamimi is a recognized financial and banking expert with over 20 years of expertise in audit and assurance, leading the firm's strategic vision and client relationships across the United Arab Emirates, frequently appointed by the courts to handle high-profile corporate restructuring and insolvency cases.
                    </p>
                    
                    <h4 className="font-display text-base md:text-lg font-semibold mb-2 text-[hsl(22,78%,26%)]">
                      Core Expertise & Roles
                    </h4>
                    <p className="text-muted-foreground text-sm leading-relaxed mb-4 md:mb-5 !text-justify">
                      <strong>Bankruptcy Trustee:</strong> He is a registered expert with the UAE Ministry of Justice and Dubai/Abu Dhabi Courts. He is notably recognized for his role as the court-appointed trustee in major restructuring cases, such as the Neopharma and KBBO Group bankruptcy proceedings.
                    </p>

                    <h4 className="font-display text-base md:text-lg font-semibold mb-2 text-[hsl(22,78%,26%)]">
                      Professional Impact
                    </h4>
                    <p className="text-muted-foreground text-sm leading-relaxed !text-justify">
                      Mr. Salem Balama is considered a key figure in the UAE's evolving insolvency landscape. His work involves navigating the legal and financial complexities of the UAE Bankruptcy Law to help distressed companies restructure their debts and maintain operational continuity.
                    </p>
                  </CardContent>
                </Card>

                {}
                <div className="p-6 md:p-8 lg:p-10 flex flex-col">
                  <h3 className="font-display text-xl sm:text-2xl md:text-3xl font-bold mb-2 text-[hsl(22,78%,26%)]">Salem Ballama</h3>
                  <p className="text-foreground text-base sm:text-lg md:text-xl font-semibold">
                    {founder.title}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
            {remainingTeam.map((member, i) => <Card key={member.id} data-index={i} className={`group relative overflow-hidden border border-border shadow-soft hover:shadow-medium transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-0.5 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${(i + 1) * 50}ms` : "0ms"
          }}>
                <CardContent className="p-0">
                  <div className="relative">
                    <SafeHydrate><Avatar className="w-full h-56 sm:h-64 rounded-none rounded-t-xl bg-muted">
                      <AvatarImage src={member.image} alt={member.name} className="object-contain object-center w-full h-full" />
                      <AvatarFallback className="w-full h-full rounded-none bg-muted text-3xl md:text-4xl font-display font-semibold text-muted-foreground">
                        {member.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="absolute inset-0 rounded-t-xl border-2 border-transparent group-hover:border-primary/60 transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] pointer-events-none" />
                  </div>

                  <div className="p-4 sm:p-6">
                    <h3 className="font-display text-lg sm:text-xl font-semibold mb-1 text-[hsl(22,78%,26%)]">
                      {member.name}
                    </h3>
                    <p className="text-foreground text-sm sm:text-base font-medium mb-3">
                      {member.title}
                    </p>
                    <p className="text-muted-foreground text-sm leading-relaxed !text-justify">
                      {member.bio}
                    </p>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}